module.exports = __webpack_public_path__ + "static/media/game-bosstalkingwrong.afa0c13b.png";